export enum NotificationType {
  Email = 'email',
  Sms = 'sms',
}
